var HtmlComponent_default = {
  "htmlComponent": "CzRJD",
  "htmlComponent_placeholder": "ZOR0Q"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
